<div class="loader" *ngIf="isGroupLoading">
  <app-three-dots-blinking></app-three-dots-blinking>
</div>
<div class="container" *ngIf="!isGroupLoading">
  <div class="header-wrapper">
    <div class="header">
      <h2>{{headerText}}</h2>
      <label>{{'reporting.SHOWING' | transloco}} {{activeReportGroup}} - {{'reporting.PRACTICE_SESSIONS' | transloco}}</label>
    </div>
    <div class="export-list">
      {{'reporting.EXPORT_LEARNER_LIST' | transloco}} <img src="/assets/icons/download-01.svg">
    </div>
  </div>
  <div class="labels-wrapper">
    <div class="labels">
      <ng-container *ngIf="!showBreadCrums">
        <div class="name" [class.active]="group.active" (click)="setGroup(group)" *ngFor="let group of reportGroups">
          {{group.reportGroupName}}</div>
      </ng-container>
      <ng-container *ngIf="showBreadCrums">
        <mat-select class="reporting" [(value)]="selectedReportGroup">
          <mat-option *ngFor="let group of reportGroups" [value]="group" (click)="resetGroup(group.reportGroupUuid)">
            {{ group.reportGroupName }}
          </mat-option>
        </mat-select>
        <div class="vertical-line"></div>
        <div class="breadcrums">
          <div class="name" (click)="setGroup(selectedReportGroup)">{{selectedReportGroup.reportGroupName}} <img
              src="/assets/icons/arrow/chevron-right-grey.svg"></div>
          <div class="name" [class.last-name]="last"
            *ngFor="let group of activeReportGroups[0].nestedGroups;  let last = last"
            (click)="pruneNestedGroup(group)">
            {{group.reportGroupName}} <img *ngIf="!last" src="/assets/icons/arrow/chevron-right-grey.svg"></div>
        </div>
      </ng-container>
    </div>
    <div class="avg-cta" *ngIf="reportGroups.length > 0">
      <div class="avg-practice" [class.active]="selectedCta === 'practice'" (click)="setCta('practice')">{{'reporting.AVG_PRACTICES_LABEL' | transloco}}
      </div>
      <div class="avg-score" [class.active]="selectedCta === 'score'" (click)="setCta('score')">{{'reporting.AVG_SCORE_LABEL' | transloco}}</div>
    </div>
  </div>

  <div #chartContainer class="chart-container">
    <div class="loader" *ngIf="isPreCalLoading && isReportGroupDataAvailable">
      <app-three-dots-blinking></app-three-dots-blinking>
    </div>
  </div>
  <div *ngIf="noDataMsg" class="error">{{noDataMsg}}</div>
  <div *ngIf="shouldShowGroup()" class="group">* {{'reporting.ASTERICK_GROUP' | transloco}}</div>
</div>